import UserBasicSettings from './UserBasicSettings.js';
import UserInvoiceSettings from './UserInvoiceSettings.js';
import UserInvoiceSettingsOrder from './UserInvoiceSettingsOrder.js';
import AddAdvertise from './AddAdvertise.js';
import PasswordChange from './PasswordChange.js';
import UserContactForm from './UserContactForm.js';
import MainContactForm from './MainContactForm.js';
import Order from './Order.js';
import SubmitFiltersModal from './SubmitFiltersModal.js';
import UpdateAdvertiseDates from './UpdateAdvertiseDates.js';
import LockOnSubmit from './LockOnSubmit';

export const forms = () => {
  new LockOnSubmit();

  new UserBasicSettings();
  new UserInvoiceSettings();
  new AddAdvertise();
  new PasswordChange();
  // new UserContactForm();
  // new MainContactForm();
  new Order();
  new SubmitFiltersModal();
  new UserInvoiceSettingsOrder();

  new UpdateAdvertiseDates();
}



// WEBPACK FOOTER //
// ./resources/assets/js/Forms/Forms.js